<template>
	<div class="wrapper">
		<parallax class="section page-header header-filter" :style="headerStyle"></parallax>
		<div class="main main-raised">
			<div class="section profile-content">
				<div class="container">
					<div class="md-layout">
						<div class="md-layout-item mx-auto">
							<div class="profile">
								<div class="avatar">
									<img :src="img" alt="Amrei Schaal Psychologische Psychotherapeutin Profilbild"
										class="
											img-raised
											rounded-circle
											img-fluid
										" />
								</div>
								<div class="name">
									<h3 class="title">Amrei Schaal</h3>
									<h6>Psychologische Psychotherapeutin</h6>
								</div>
							</div>
						</div>
					</div>
					<div class="description text-left">
						<h3>
							Meine Intention ist es, Menschen in den
							verschiedensten Notlagen und Krisensituationen
							wertschätzend zu begleiten und in der gewünschten
							Entwicklung zu unterstützen.
						</h3>
						<h3>
							Mir ist es wichtig, Ihnen einen Raum zu geben, in
							dem Sie zur Ruhe kommen können und der einen
							Unterschied macht.
						</h3>
					</div>
					<div class="md-size-100 md-small-size-100 mt-30">
						<tabs :tab-name="['Qualifikation', 'Arbeitsweise']" plain color-button="info">
							<template slot="tab-pane-1">
								<div class="md-layout">
									<div class="tim-typo">
										<div class="md-layout-item md-size-80">
											<h3>Diplom- Psychologin</h3>
											<h5>
												Psychologische
												Psychotherapeutin, Fachkunde
												Verhaltenstherapie (VT)
											</h5>
											<h3>Approbation</h3>
											<h1 class="text-large">
												Eintrag ins Arztregister durch
												die Kassen&auml;rztliche
												Vereinigung Baden-
												W&uuml;rttemberg (KVBW)
											</h1>
											<hr />
											<h4>Einzel- und Gruppentherapie</h4>
											<h4>
												Mitgliedschaften:
												Landespsychotherapeutenkammer
												Baden-W&uuml;rttemberg
											</h4>
										</div>
									</div>
								</div>
							</template>
							<template slot="tab-pane-2">
								<div class="md-layout">
									<div class="tim-typo">
										<div class="md-layout-item md-size-80">
											<h4>
												Aufgrund meines humanistischen
												Menschenbildes bin ich davon
												überzeugt, dass jeder Mensch
												alle notwenigen Kompetenzen und
												Ressourcen in sich trägt, um
												seine Probleme zu lösen.
											</h4>
											<h3>
												Ich glaube an Ihre Kraft, sich
												in Krisen neu zu orientieren und
												dass Sie selbst ein gutes Gefühl
												dafür haben, was Sie brauchen
												und was gut für Sie ist.
											</h3>
											<h4>
												Sie in diesem Expertentum für
												sich selbst zu unterstützen und
												Ihnen zu helfen, Kompetenzen und
												Ressourcen zu aktivieren, sehe
												ich als eine meiner Aufgaben im
												therapeutischen Prozess.
											</h4>
											<h4>
												Dabei verbinde ich das Arbeiten
												an gegenwartsorientierten
												Lösungen mit einem Bewusstsein
												für deren Entstehungsgeschichte
												und Hintergründe. Oft können
												gegenwärtige Schwierigkeiten und
												Konflikte mit einem Wissen um
												die lebensgeschichtlich
												relevante Zusammenhänge anders
												verstanden und kraftvoller
												verändert werden.
											</h4>
											<h4>
												In meine grundlegende
												therapeutische Haltung und
												Arbeitsweise beziehe ich Ansätze
												und Methoden weiterer
												therapeutischer Schulen mit ein,
												wenn das zu Ihrer Situation
												passt und einen Mehrwert bietet.
											</h4>
											<h4>
												Somit können Elemente aus
												körperorientierten Therapien,
												systemische und
												achtsamkeitsbasierte Ansätze
												oder Entspannungsverfahren in
												meine Arbeit einfließen.
											</h4>
											<h4>
												Dabei arbeite ich nach
												anerkannten und aktuellen
												wissenschaftlichen Standards der
												klinischen Psychologie.
											</h4>
											<h4>
												Die unbedingte Wertschätzung
												Ihrer Person und Ihrer
												Geschichte, Transparenz und ein
												Austausch auf Augenhöhe sind für
												mich die wichtigsten Parameter
												im Kontakt mit Ihnen.
											</h4>
										</div>
									</div>
								</div>
							</template>
						</tabs>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import { Tabs } from "@/components";

export default {
	components: {
		Tabs,
	},
	bodyClass: "profile-page",
	data() {
		return {
			tabPane1: [
				{ image: require("@/assets/img/examples/studio-2.jpg") },
				{ image: require("@/assets/img/examples/studio-2.jpg") },
				{ image: require("@/assets/img/examples/studio-4.jpg") },
				{ image: require("@/assets/img/examples/studio-5.jpg") },
			],
			tabPane2: [
				{ image: require("@/assets/img/practice/practice_01.jpeg") },
				{ image: require("@/assets/img/practice/practice_02.jpeg") },
				{ image: require("@/assets/img/practice/practice_03.jpeg") },
				{ image: require("@/assets/img/examples/studio-2.jpg") },
				{
					image: require("@/assets/img/examples/mariya-georgieva.jpg"),
				},
			],
			tabPane3: [
				{
					image: require("@/assets/img/cali-strokes.jpg"),
				},
				{ image: require("@/assets/img/examples/studio-3.jpg") },
				{ image: require("@/assets/img/examples/clem-onojeghuo.jpg") },
				{ image: require("@/assets/img/examples/olu-eletu.jpg") },
				{ image: require("@/assets/img/examples/studio-1.jpg") },
			],
		};
	},
	props: {
		header: {
			type: String,
			default: require("@/assets/img/benjamin-voros-unsplash-mountain-stars_sized.jpeg"),
		},
		img: {
			type: String,
			default: require("@/assets/img/faces/amrei_11_done_3_auto_x2_minified.jpeg"),
		},
	},
	computed: {
		headerStyle() {
			return {
				backgroundImage: `url(${this.header})`,
			};
		},
	},
	mounted() {
	},
	methods: {
		runWebGL() {
		},
	},
};
</script>

<style lang="scss" scoped>
.section {
	padding: 0;
}

.text-large {
	font-size: large;
}

.subhead:first-of-type:first-letter {
	font-size: xx-large;
	line-height: 1;
}

.no-pad {
	padding-left: unset;
}

.mt-30 {
	margin-top: 30px;
}

.tim-typo {
	margin-top: 40px;
	padding-left: 15%;
}

.profile-tabs::v-deep {
	.md-card-tabs .md-list {
		justify-content: center;
	}

	[class*="tab-pane-"] {
		margin-top: 3.213rem;
		padding-bottom: 50px;

		img {
			margin-bottom: 2.142rem;
		}
	}
}
</style>
